import { render, staticRenderFns } from "./add-new-period.vue?vue&type=template&id=555b9758"
import script from "./add-new-period.ts?vue&type=script&lang=ts&external"
export * from "./add-new-period.ts?vue&type=script&lang=ts&external"
import style0 from "./add-new-period.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555b9758')) {
      api.createRecord('555b9758', component.options)
    } else {
      api.reload('555b9758', component.options)
    }
    module.hot.accept("./add-new-period.vue?vue&type=template&id=555b9758", function () {
      api.rerender('555b9758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin-periods/add-new-period/add-new-period.vue"
export default component.exports